export default "__VITE_ASSET__DGAwCw5b__"